import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { KONTRACTOR_API } from '../../common/utils/api.bobcat';

import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';


@Injectable()
export class HttpService {

  constructor(private http: HttpClient, private router: Router) {
    this.http = http;
  }

  // point s'entrée
  get(url: string, params: Array<string> = null, apiv2: boolean = false) {
    return this.request("get", url, params, apiv2);
  }

  post(url: string, params: any, apiv2: boolean = false) {
    return this.request("post", url, params, apiv2);
  }

  delete(url: string, params: any, apiv2: boolean = false) {
    return this.request("delete", url, params, apiv2);
  }

  private createAuthorizationHeader(headers: HttpHeaders) {
    headers.set('Content-Type', 'application/x-www-form-urlencoded');
    headers.set('Authorization', 'Basic Ym9iY2F0Omplc3Vpc3VuY2hhdA==');
  }

  // on fait les header dans les gestionaire http et pas dans chaque service object un par un!
  private getHttpPostParams(params: any): HttpParams {
    let data = new HttpParams();
    for (let key in params) {
      data = data.append(key, params[key]);
    }
    return data;
  }
  private getHttpGetParams(params: any): string {
    let data = "";
    if (params != null) {
      if (params instanceof Array) {

        for (let param of params) {
          if (param) {
            if (typeof param != "string") {
              param = <string>param.toString();
            }
            param = param.split("/").join(":");
            if (param.indexOf(".") != -1) {
              param = param.substring(0, param.indexOf("."));
            }
            data += "/" + param;
          }
        }
      }
      else {
        console.warn("incorrect get params")
      }
    }

    return data;
  }
  private request(type: "get" | "delete" | "post", url, params?, apiv2: boolean = false) {
    if (this.verifTimeout() || url == KONTRACTOR_API.login) {
      if (url != KONTRACTOR_API.login) {
        this.setSession();
      }
      else {
        console.log("authentification")
      }
      //gestion headers and params
      let headers = new HttpHeaders;
      this.createAuthorizationHeader(headers);
      if (apiv2) {
        url = KONTRACTOR_API.baseHrefApi + url;
      }

      //envoi de la requete
      switch (type) {
        case "get":
          url += this.getHttpGetParams(params);
          return this.http.get(url, {
            headers: headers
          });
        case "post":
          if (params) {
            if (!(params instanceof HttpParams)) {
              params = this.getHttpPostParams(params);
            }
            else {
              console.warn("HttpParams given")
            }
          }
          return this.http.post(url, params, {
            headers: headers
          });
        case "delete":
          return this.http.delete(url, {
            headers: headers
          });
      }
    }
    else {
      return this.logout();
    }

  }


  //?
  getUrlSearchParams() {
    let urlsearchparams = new URLSearchParams;
    return urlsearchparams;
  }

  setSession() {
    let date = moment();
    date.add(1, "hour");//c'est le timeout de connexion
    localStorage.setItem('konTractorTimeout', date.format("YYYYMMDDHHmm"));
  }

  verifTimeout() {
    let stringData = localStorage.getItem('konTractorTimeout');
    if (stringData) {
      let date = moment(stringData, "YYYYMMDDHHmm");
      console.log(moment().isSameOrBefore(date), date, moment());
      return moment().isSameOrBefore(date);
    }
    else {
      return false;
    }

  }

  logout() {
    return new Observable(observer => {
      this.router.navigate([''])
    })
  }




}


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/common/utils/http.service.ts